import React, { useState } from 'react';
import { Zap } from 'lucide-react';
import { InfoBox, InputGroup } from '../Common';

const SharpeTool = () => {
    const [pr, setPr] = useState(24);
    const [rfr, setRfr] = useState(6);
    const [v, setV] = useState(12);

    const sh = v > 0 ? (pr - rfr) / v : 0;

    return (
        <div className="tct-tool-container">
            <div className="tct-panel-title">Sharpe Ratio Estimator</div>
            <div className="tct-input-wrap d-flex flex-wrap gap-2">
                <InputGroup label="Port. Return %" value={pr} onChange={setPr} />
                <InputGroup label="Risk Free Rate %" value={rfr} onChange={setRfr} />
                <InputGroup label="Volatility %" value={v} onChange={setV} />
            </div>
            <div className="tct-results-grid mt-4">
                <div className="tct-card tct-green">
                    <div className="tct-data-row"><span className="tct-label">Sharpe Ratio</span><span className="tct-value val-green big-value">{sh.toFixed(2)}</span></div>
                </div>
            </div>
            <InfoBox
                title="Sharpe Ratio in Trading Explained"
                meta="Learn how Sharpe ratio measures risk adjusted returns for trading strategies"
                sections={[
                { title: "Introduction", content: "Sharpe ratio measures return relative to volatility.<br><br>It helps compare strategies." },
                { title: "Example", content: "Annual return = 24%<br>Volatility = 12%<br><br>Sharpe ratio = 2.<br><br>This indicates strong performance." }
                ]}
            />
        </div>
    );
};

export default SharpeTool;
